import { useState } from 'react';
import PropTypes from 'prop-types';
import Iconify from 'src/components/Iconify';
import { CodeBlock } from './CopyCode';

// ----------------------------------------------------------------------
// Aba "Instalação": snippet de embed do widget (padrão settings + loader
// assíncrono, mesmo estilo Intercom/Crisp/Zendesk). Um bloco por canal webchat
// vinculado a este projeto, já que cada canal tem seu próprio canalId.

function buildSnippet(canalId, apiHost) {
    const host = apiHost || '<SEU_API_HOST>';
    return `<script>
  window.laisChatSettings = {
    canalId: "${canalId}",
    apiHost: "${host}",
  };
</script>
<script>
  (function () {
    function load() {
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = 'https://cdn.lais.app/scripts/laischat.js';
      var x = document.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    }
    if (document.readyState === 'complete') {
      load();
    } else if (window.attachEvent) {
      window.attachEvent('onload', load);
    } else {
      window.addEventListener('load', load, false);
    }
  })();
</script>`;
}

export default function ChannelWebchatInstall({ canais }) {
    const [apiHost, setApiHost] = useState('');

    return (
        <div className="flex flex-col gap-5 mt-2 animate-in fade-in duration-300">
            {/* Como funciona */}
            <div className="bg-violet-50/50 rounded-xl border border-violet-100 p-5">
                <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-violet-100 flex-shrink-0">
                        <Iconify icon="streamline-plump:web" width={20} className="text-violet-600" />
                    </div>
                    <div className="text-sm text-gray-700 leading-relaxed">
                        <p className="font-bold text-gray-900 mb-1">Como funciona</p>
                        <p>
                            Cole o snippet abaixo antes do <code className="font-mono text-violet-600">&lt;/body&gt;</code>{' '}
                            do site do cliente. O primeiro bloco define a configuração (<code className="font-mono text-violet-600">canalId</code>/
                            <code className="font-mono text-violet-600">apiHost</code>), o segundo injeta o script do widget de forma
                            assíncrona — o mesmo padrão usado por Intercom, Crisp e Zendesk.
                        </p>
                    </div>
                </div>
            </div>

            {/* apiHost */}
            <div className="bg-white rounded-xl border border-gray-100 p-5 flex flex-col gap-3">
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                    Endereço do backend webchat (apiHost)
                </p>
                <input
                    type="text"
                    value={apiHost}
                    onChange={(e) => setApiHost(e.target.value)}
                    placeholder="https://webchat-api.seu-dominio"
                    className="w-full border border-gray-200 rounded-xl px-3 py-2 text-sm font-mono text-gray-700 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 outline-none"
                />
                <p className="text-[11px] text-gray-400">
                    Preencha para já deixar o snippet abaixo pronto para copiar. Não é salvo — é só um preenchimento
                    local para gerar o código.
                </p>
            </div>

            {/* Snippet por canal */}
            {canais.length === 0 ? (
                <div className="bg-gray-50 rounded-xl border border-gray-100 p-6 text-center">
                    <p className="text-sm text-gray-500">
                        Nenhum canal webchat vinculado a este projeto ainda.
                    </p>
                    <p className="text-xs text-gray-400 mt-1">
                        Vincule um canal na aba <b>Canais</b> para gerar o snippet de instalação.
                    </p>
                </div>
            ) : (
                canais.map((canal) => (
                    <div key={canal._id} className="bg-white rounded-xl border border-gray-100 p-5 flex flex-col gap-3">
                        <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                            {canal.nome}
                        </p>
                        <CodeBlock code={buildSnippet(canal._id, apiHost)} />
                    </div>
                ))
            )}
        </div>
    );
}

ChannelWebchatInstall.propTypes = {
    canais: PropTypes.arrayOf(
        PropTypes.shape({
            _id: PropTypes.string,
            nome: PropTypes.string,
        })
    ),
};

ChannelWebchatInstall.defaultProps = {
    canais: [],
};
